import { useEffect, useState } from "react";

const OPEN_FROM = 8;
const OPEN_TO = 20;

const localHour = (tz) => Number(new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", hour12: false }).format(new Date()));

export const useOfficeOpen = (tz) => {
  const [hour, setHour] = useState(() => localHour(tz));
  useEffect(() => {
    const id = setInterval(() => setHour(localHour(tz)), 60_000);
    return () => clearInterval(id);
  }, [tz]);
  return hour >= OPEN_FROM && hour < OPEN_TO;
};

export const OpenTag = ({ tz, className = "", testid }) => {
  const open = useOfficeOpen(tz);
  return (
    <span data-testid={testid} data-open={open}
      className={`font-mono-x inline-flex items-center gap-2 rounded-full px-3 py-1 text-[0.7rem] font-bold uppercase tracking-[0.14em] ${open ? "bg-[#D4FF3D] text-[#0E0E10]" : "bg-[#0E0E10] text-[#F1ECE2] ring-1 ring-white/20"} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${open ? "animate-pulse bg-[#0E0E10]" : "bg-[#FF4D1A]"}`} aria-hidden="true" />
      {open ? "open now" : "back in the morning"}
    </span>
  );
};
